import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import "./index.css";

async function start() {
  // `VITE_MOCK=1` serves fixtures from src/mocks instead of the API, so every screen works without a backend.
  // The import is behind the flag, so production builds do not load the fixtures.
  if (import.meta.env.VITE_MOCK === "1") {
    const { installMocks } = await import("./mocks/index.ts");
    installMocks();
  }
  const root = document.getElementById("root");
  if (!root) throw new Error("#root is missing from index.html");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
